import React, { useEffect } from "react";

import { Input, AutoComplete, Icon, Select } from "antd";

import { connect } from "react-redux";

import {
  fetchOriginators,
  setOriginatorId,
  setOriginatorName,
  setSearchString,
  cleanup,
} from "rx/selectoriginator";

function SelectOriginatorRxComponent(props) {
  useEffect(() => {
    let controller = new AbortController();
    props.fetchOriginators(props.searchString, controller.signal);

    return () => {
      controller.abort();
    };
  }, [props.searchString]);

  useEffect(() => {
    // Specify how to clean up after this effect:
    return function cleanup() {
      props.cleanup();
    };
  }, []);

  return (
    <div>
      <AutoComplete
        {...props}
        className="global-search"
        size="large"
        dataSource={props.originators.map(renderOption)}
        onChange={(value) => props.setSearchString(value)}
        onSelect={(value, option) => {
          props.setOriginatorId(value);
          props.setOriginatorName(option.props.text);
        }}
        optionLabelProp="text"
        defaultValue={props.originatorName}
      >
        <Input
          placeholder={"Originator Name"}
          prefix={<Icon type="search" />}
        />
      </AutoComplete>
    </div>
  );
}

const renderOption = (item) => {
  return (
    <Select.Option key={item.id} text={item.displayName}>
      <span className="searchOriginatorId">{item.id}</span>
      <span className="searchOriginatorName"> {item.displayName}</span>
    </Select.Option>
  );
};

const mapStateToProps = (state) => {
  return {
    searchString: state.selectOriginator.searchString,
    originators: state.selectOriginator.data,
    originatorName: state.selectOriginator.originatorName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cleanup: () => dispatch(cleanup()),
    fetchOriginators: (value, cancelSignal) =>
      dispatch(fetchOriginators(value, cancelSignal)),
    setOriginatorId: (originatorId) => dispatch(setOriginatorId(originatorId)),
    setOriginatorName: (originatorName) =>
      dispatch(setOriginatorName(originatorName)),
    setSearchString: (searchString) => dispatch(setSearchString(searchString)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectOriginatorRxComponent);
